import { render, staticRenderFns } from "./UBindIFrame.vue?vue&type=template&id=6e5dac2b&scoped=true&"
import script from "./UBindIFrame.vue?vue&type=script&lang=js&"
export * from "./UBindIFrame.vue?vue&type=script&lang=js&"
import style0 from "./UBindIFrame.vue?vue&type=style&index=0&id=6e5dac2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5dac2b",
  null
  
)

export default component.exports